import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { isDefined } from '@fi-shared/utils/is-defined';
import { WidgetContentModel } from '../../../../widget/model/widget-content.model';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { ModuleType } from '@fi-shared/types';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { removeItem } from '@fi-shared/utils/remove-item';

@Component({
    selector: 'fi-appearance-sidebar-edit-widgets-list',
    templateUrl: './widgets-list.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./widgets-list.component.scss'],
    standalone: false,
})
export class FiAppearanceSidebarEditWidgetsListComponent {
    @Input() siteDesignId: number;
    @Input() widgetsList: WidgetContentModel[];
    @Input() selectedWidget;
    @Input() moduleType: ModuleType;
    @Input() widgetsMap: { [prop: number]: WidgetModel };

    @Output() selectWidgetControl = new EventEmitter<WidgetContentModel>();
    @Output() widgetDragStart = new EventEmitter();
    @Output() widgetDragEnd = new EventEmitter();

    constructor(private contentLanguagesService: ContentLanguagesService) {}

    onWidgetDrop($event) {
        const insertIndex = isDefined($event.index) ? $event.index : this.widgetsList.length,
            item = $event.data;
        // on drop control we need re-create original placeholder because of dnd-list copy as plain object
        // if a widget dropped from sidebar - need to create a new placeholder content
        if ($event.type == 'control') {
            this.widgetsList.splice(
                insertIndex,
                0,
                new WidgetContentModel(this.contentLanguagesService.GetContentLanguages(), item),
            );
        } else if ($event.type == 'widget') {
            // on adding a new control - add his widget to a storage
            const widgetContent = new WidgetContentModel(this.contentLanguagesService.GetContentLanguages(), {
                WidgetId: item.Id,
                ModuleType: this.moduleType,
                WidgetSetting: item.Settings,
                SortOrder: $event.index,
                WidgetType: item.WidgetType,
                SiteDesignId: this.siteDesignId,
            });
            this.widgetsList.splice(insertIndex, 0, widgetContent);
            // widgetContent.InitializeWidgetContentLanguageLabels(ContentLanguagesService.GetContentLanguages());
        }
    }

    onWidgetMoved(control: WidgetContentModel) {
        removeItem(this.widgetsList, control);
    }

    widgetControlClick(control: WidgetContentModel) {
        this.selectWidgetControl.emit(control);
    }

    dndStart() {
        this.widgetDragStart.emit();
    }

    dndEnd() {
        this.widgetDragEnd.emit();
    }
}
